import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

export default class SwatchButton extends React.Component {
  static propTypes = {
    color: PropTypes.string,
    handleClick: PropTypes.func,
    isActive: PropTypes.bool,
  };

  static defaultProps = {
    color: '',
    handleClick: () => {},
    isActive: false,
  };

  render() {
    return (
      <div
        className={`SwatchButton ${this.props.isActive ? 'isActive' : ''}`}
        onClick={this.props.handleClick}
        style={{
          borderColor: this.props.isActive ? this.props.color : null,
        }}>
        <div
          className={'SwatchButton--fill'}
          style={{
            backgroundColor: this.props.color,
          }}
        />
      </div>
    );
  }
}
